<template>
  <v-card
    class="mx-auto grey lighten-4"
  >
    <v-card-title>
      <v-icon
        large
        left
      >
        mdi-cast-education
      </v-icon>
      <img
        :src="require('../../assets/logo_qclass_ead_png.png')"
        alt="Qclass EAD"
        align="center"
        justify="center"
        contain
        height="35x"
        max-height="60px"
      >
    </v-card-title>

    <v-card-text class="headline font-weight-bold">
      <AgendaAulaTeorico />
    </v-card-text>
  </v-card>
</template>
<script>
import AgendaAulaTeorico from './AgendaAulaTeorico';
  export default {
    components:{
      AgendaAulaTeorico,
    },
    data () {
      return {}
    },
  }
</script>
